// extracted by mini-css-extract-plugin
export default {"container":"questionMark_container__wjU77","circle":"questionMark_circle__cSTip","question":"questionMark_question__X1XA8","modal":"questionMark_modal__ZUUZs"};